export default {
  infura_key: 'fbffa83bae984207a7260b02066c9b0f' // goerli
}
